import { render, staticRenderFns } from "./DocumentExpirationReminders.vue?vue&type=template&id=316028af&scoped=true"
import script from "./DocumentExpirationReminders.vue?vue&type=script&lang=js"
export * from "./DocumentExpirationReminders.vue?vue&type=script&lang=js"
import style0 from "./DocumentExpirationReminders.vue?vue&type=style&index=0&id=316028af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316028af",
  null
  
)

export default component.exports